class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
  }

  connectedCallback() {
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', this.onRemoveClick.bind(this));
    this.addEventListener('click', this.onQuantityButtonClick.bind(this));
    this.addEventListener('change', this.onQuantityInputChange.bind(this));
  }

  open() {
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    this.querySelector('.drawer__inner')?.focus();
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  async onRemoveClick(event) {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;

    event.preventDefault();
    await this.updateLine(Number(button.dataset.line), 0, button);
  }

  async onQuantityButtonClick(event) {
    const button = event.target.closest('[data-cart-quantity-button]');
    if (!button) return;

    event.preventDefault();

    const currentQuantity = Number(button.dataset.quantity || 0);
    const step = Number(button.dataset.step || 1);
    const max = button.dataset.max ? Number(button.dataset.max) : null;
    const direction = button.dataset.cartQuantityButton;
    let nextQuantity = direction === 'plus' ? currentQuantity + step : currentQuantity - step;

    if (max !== null) nextQuantity = Math.min(nextQuantity, max);
    nextQuantity = Math.max(nextQuantity, 0);

    await this.updateLine(Number(button.dataset.line), nextQuantity, button);
  }

  async onQuantityInputChange(event) {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    const value = Number(input.value);
    const max = input.max ? Number(input.max) : null;
    const quantity = Math.max(0, max !== null ? Math.min(value, max) : value);

    input.value = quantity;
    await this.updateLine(Number(input.dataset.line), quantity, input);
  }

  async updateLine(line, quantity, control) {
    if (!line || Number.isNaN(quantity)) return;

    control?.setAttribute('disabled', 'disabled');
    this.setLineControlsDisabled(line, true);

    try {
      const response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || state.message || window.cartStrings.error);
      this.renderContents(state);
    } catch (error) {
      window.location.href = window.routes.cart_url;
    } finally {
      control?.removeAttribute('disabled');
      this.setLineControlsDisabled(line, false);
    }
  }

  setLineControlsDisabled(line, disabled) {
    this.querySelectorAll(`[data-line="${line}"]`).forEach((control) => {
      if (disabled) {
        control.setAttribute('disabled', 'disabled');
      } else {
        control.removeAttribute('disabled');
      }
    });
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', section: 'cart-drawer', selector: 'cart-drawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    ];
  }

  renderContents(parsedState) {
    if (!parsedState.sections) return;

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections[section.section];
      if (!html) return;

      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      const target = document.querySelector(section.selector);
      if (!source || !target) return;

      if (section.selector === 'cart-drawer') {
        target.replaceWith(source);
      } else {
        target.innerHTML = source.innerHTML;
      }
    });

    document.querySelector('cart-drawer')?.open();
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

document.addEventListener('click', (event) => {
  const cartLink = event.target.closest('a[href$="/cart"], a[href="/cart"]');
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartLink || !cartDrawer || cartLink.closest('cart-drawer')) return;

  event.preventDefault();
  cartDrawer.open();
});
